import React from 'react';
import { Link as RouterLink } from "react-router-dom";
import { Button as EcoButton } from "@bsw/react-nightingale";

export const Button = (props) => {
    const buttonAs = props?.as || (props?.href ? 'a' : props?.to ? RouterLink : undefined);

    return <EcoButton
        {...props}
        as={buttonAs}
    />;
}
